import React from "react";
import { FlexBox } from "@pagepro-monorepo/ui/lib/components/styles/Grid";

import NumberedListItemBox from "./partials/NumberedListItemBox";
import { NumberedListProps } from "./types";
import * as Styled from "./styles";

const NumberedList: React.FC<NumberedListProps> = ({ items }) =>
  items.length ? (
    <FlexBox
      as="ul"
      flexDirection="column"
      aria-label="Tabs with number"
    >
      {items.map(({ key, number, title, description, color }) => (
        <Styled.ListItem {...{ key }}>
          <NumberedListItemBox
            {...{ number, title, description, color }}
          />
        </Styled.ListItem>
      ))}
    </FlexBox>
  ) : null;

export default NumberedList;
